export const sales = {
  title: 'Ventes',
  currency: {
    code: 'MAD',
    symbol: 'DH',
    position: 'after',
    decimalSeparator: ',',
    thousandSeparator: ' '
  },
  columns: {
    num: 'N° Vente',
    date: 'Date',
    customer: 'Client',
    total: 'Total',
    status: 'Statut',
    paymentMethod: 'Paiement',
    paymentStatus: 'État du paiement',
    items: 'Articles',
    basicInfo: 'Informations de base',
    financialInfo: 'Détails financiers',
    systemInfo: 'Informations système',
    createdAt: 'Date de création',
    updatedAt: 'Dernière modification'
  },
  filters: {
    search: {
      label: 'Rechercher',
      placeholder: 'Rechercher une vente...'
    },
    sort: {
      label: 'Trier par',
      directions: {
        asc: 'Croissant',
        desc: 'Décroissant'
      }
    },
    status: {
      label: 'Statut',
      placeholder: 'Tous les statuts',
      options: {
        completed: 'Terminée',
        pending: 'En attente',
        cancelled: 'Annulée'
      }
    },
    paymentMethod: {
      label: 'Méthode de paiement',
      placeholder: 'Toutes les méthodes',
      options: {
        cash: 'Espèces',
        card: 'Carte',
        transfer: 'Virement',
        check: 'Chèque'
      }
    },
    paymentStatus: {
      label: 'État du paiement',
      placeholder: 'Tous les états',
      options: {
        paid: 'Payé',
        partial: 'Partiellement payé',
        unpaid: 'Non payé'
      }
    }
  },
  actions: {
    newSale: 'Nouvelle vente',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    print: 'Imprimer'
  },
  form: {
    createTitle: 'Nouvelle vente',
    editTitle: 'Modifier la vente',
    customer: 'Client',
    selectCustomer: 'Sélectionner un client',
    status: 'Statut',
    paymentMethod: 'Méthode de paiement',
    paymentStatus: 'État du paiement',
    items: 'Articles',
    selectProduct: 'Sélectionner un produit',
    addItem: 'Ajouter un article',
    removeItem: 'Supprimer',
    quantity: 'Quantité',
    notes: 'Notes',
    total: 'Total',
    save: 'Enregistrer',
    update: 'Mettre à jour',
    cancel: 'Annuler',
    saving: 'Enregistrement...'
  },
  details: {
    title: 'Détails de la vente',
    customerInfo: 'Informations client',
    saleInfo: 'Informations vente',
    noCustomer: 'Client non spécifié',
    createdAt: 'Date de création',
    updatedAt: 'Dernière modification',
    itemName: 'Article',
    unitPrice: 'Prix unitaire',
    close: 'Fermer'
  },
  confirmations: {
    delete: 'Êtes-vous sûr de vouloir supprimer cette vente ?'
  },
  errors: {
    insufficientStock: 'Stock insuffisant pour ce produit'
  },
  pagination: {
    totalItems: 'Total des ventes',
    itemsPerPage: 'Ventes par page',
    page: 'Page',
    of: 'sur',
    next: 'Suivant',
    previous: 'Précédent',
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    items: 'ventes'
  }
}; 